import { STATES } from "../../constants/states";

export function StateDropdown({
  value,
  setValue,
  error,
}: {
  value: string;
  setValue: any;
  error: string;
  halfWidth?: boolean;
}) {
  const effectiveValue = value || "MD";

  return (
    <div className="p-field" style={{ marginBottom: 18 }}>
      <label className="p-label">State</label>
      <select
        className="p-select"
        value={effectiveValue}
        onChange={(e) => setValue(e.target.value)}
      >
        {STATES.map((s) => (
          <option key={s} value={s}>{s}</option>
        ))}
      </select>
      {error && <div style={{ fontSize: 12, color: "var(--maroon)" }}>{error}</div>}
    </div>
  );
}
